import {Button} from '@mantine/core'
import {IconArrowNarrowLeft} from '@tabler/icons-react'
import {Link, type LinkProps} from '@tanstack/react-router'

type DetailPageBackLinkProps = {
    to: LinkProps['to']
    listLabel: string
    /** When set, used instead of the default "Back to all {listLabel}" label. */
    backLabel?: string
}

/** Back navigation control for detail pages returning to a list view. */
export function DetailPageBackLink({to, listLabel, backLabel}: DetailPageBackLinkProps) {
    return (
        <Button
            component={Link}
            to={to}
            variant="subtle"
            size="compact-sm"
            w="fit-content"
            leftSection={<IconArrowNarrowLeft size={16} stroke={1.5} />}
        >
            {backLabel ?? `Back to all ${listLabel}`}
        </Button>
    )
}
